import { Box, styled, Typography } from '@mui/material';
import AvatarWithStatus, { AvatarWithStatusProps } from '@modules/talents/components/AvatarWithStatus';
import { RatingSelector } from './RatingViewOnly';

const ItemTextInfo = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    color: theme.palette.textSecondary.main,
    fontSize: '12px',
    lineHeight: 1,
}));

interface TalentItemProps {
    name: string;
    candidatures: number;
    date: string;
    time: string;
    location: string;
    status: string;
    rating: number;
    onClick?: (id: string) => void;
    id: string;
    isActive: boolean;
}

export const TalentItem = ({
    id,
    name,
    candidatures,
    date,
    time,
    location,
    status,
    rating,
    onClick,
    isActive,
}: TalentItemProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2.5,
                background: theme => (isActive ? '#3D3598' : theme.palette.backgroundBar.main),
                padding: 1.5,
                paddingLeft: '18px',
                border: isActive ? '2px solid #FFF' : '1px solid rgba(255, 255, 255, 0.10)',
                borderTopLeftRadius: '16px',
                borderBottomLeftRadius: '16px',
                cursor: 'pointer',
            }}
            onClick={() => onClick?.(id)}>
            <AvatarWithStatus status={status as AvatarWithStatusProps['status']} />
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                }}>
                <RatingSelector value={rating} readOnly />
                <Typography fontWeight={700}>{name}</Typography>
                <ItemTextInfo>{candidatures} candidatures</ItemTextInfo>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                    justifyContent: 'space-between',
                    alignSelf: 'stretch',
                }}>
                <ItemTextInfo sx={{ textAlign: 'right' }}>
                    {date}
                    <br />({time})
                </ItemTextInfo>
                <ItemTextInfo sx={{ lineHeight: '16px', display: 'flex', gap: 0.5 }}>
                    <i className="fi fi-br-map-marker" />
                    {location}
                </ItemTextInfo>
            </Box>
        </Box>
    );
};
